module.exports = __webpack_public_path__ + "static/media/access-denied.e25b50f8.png";